import { settings } from '../settings'

export default {
  barColorPrimary: {
    backgroundColor: `${settings.theme.palette.secondary.main}`,
  },
}
